import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowDoubleUp = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M5.292 18.294a1 1 0 0 0 1.413 1.413l5.295-5.3 5.295 5.3a.998.998 0 1 0 1.412-1.413l-6-6.007a.998.998 0 0 0-1.413 0l-6.002 6.007Z", fill: color }),
        React.createElement("path", { d: "M5.292 10.3a1 1 0 0 0 1.413 1.412L12 6.413l5.295 5.3a.998.998 0 1 0 1.412-1.413l-6-6.006a.998.998 0 0 0-1.413 0l-6.002 6.006Z", fill: color })));
};
export default factorySvgIcon(SvgArrowDoubleUp);
//# sourceMappingURL=SvgArrowDoubleUp.js.map